export const severityAllFilter = "all";
export const typeAllFilter = "all";
export const evidenceTypeEvent = "event";
export const evidenceTypeLog = "log";
export const evidenceTypeOptions = [
  { value: typeAllFilter, label: "All" },
  { value: evidenceTypeEvent, label: "Events" },
  { value: evidenceTypeLog, label: "Messages" }
];
export const EVIDENCE_CAROUSEL_ID = "investigation-evidence-overview";
